import ElectionLoginPage from './ElectionLoginPage';

export default ElectionLoginPage;
